import { render, staticRenderFns } from "./userCrowd.vue?vue&type=template&id=a1f8bde4&scoped=true"
import script from "./userCrowd.vue?vue&type=script&lang=js"
export * from "./userCrowd.vue?vue&type=script&lang=js"
import style0 from "./userCrowd.vue?vue&type=style&index=0&id=a1f8bde4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f8bde4",
  null
  
)

export default component.exports